// extracted by mini-css-extract-plugin
export var actionButton = "_dz-0";
export var attachmentLine = "_dz-1";
export var fileInput = "_dz-2";
export var fileUploadWrapper = "_dz-4";
export var footer = "_dz-3";
export var modalContent = "_dz-5";
export var paperclip = "_dz-6";
export var quillEditor = "_dz-7";